<template>
  <div class="left-aside">
    <div class="structure">
      工程结构
      <el-dropdown trigger="click" class="dropdowm">
        <Icon type="ios-funnel"/>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="displayDetailType('ALL')">显示全部</el-dropdown-item>
          <el-dropdown-item @click.native="displayDetailType('DBC')">只显示DBC</el-dropdown-item>
          <el-dropdown-item @click.native="displayDetailType('A2L')">只显示A2L</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!--<i class="el-icon-sort"></i>-->
      <div class="resize">
        <i class="el-icon-d-arrow-left" @click="$emit('minimize')"></i>
      </div>
    </div>
    <div class="search-add">
      <el-input placeholder="请输入关键词"
                v-model="filterText"
                size="small"
                class="serchInp">
        <i slot="suffix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <!-- 添加设备，单独列出来 -->
      <el-button @click="addDeviceClick()"
                 type="primary"
                 size="small"
                 plain
                 class="add-can-btn">
        添加设备
      </el-button>
    </div>
    <!--<el-button style="flex-shrink: 0;flex-grow: 0" @click="mdfConfigUpdateClick" size="small">-->
    <!--MDF配置同步-->
    <!--</el-button>-->
    <el-tree :data="treeData"
             :props="treeDisplayProps"
             ref="leftTree"
             :expand-on-click-node="true"
             node-key="id"
             :default-expand-all="IsExpandAll"
             :default-expanded-keys="allTreeNodeList"
             :style="{height:'auto'}"
             :filter-node-method="filterNode"
             :highlight-current="true"
             @node-expand="addTreeNodeList"
             @node-collapse="deleteTreeNodeList"
             :render-content="renderTreeContent">
    </el-tree>
    <!-- 增加设备-->
    <el-dialog title="增加设备"
               :visible.sync="addDeviceDialogVis"
               width="30%"
               top="30vh">
      <div class="select-content">
        <span>选择设备： </span>
        <el-cascader @change="canListChange"
                     :options="deviceListOptions"
                     change-on-select
                     v-model="addCanInput"
                     :props="addCanProps">
        </el-cascader>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDeviceDialogVis = false">取 消</el-button>
        <el-button type="primary" @click="addDeviceSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 通道配置 -->
    <el-dialog title="通道配置"
               :visible.sync="settingCanDialogVis"
               width="30%"
               top="30vh">
      <el-form :model="settingCanForm">
        <span style="font-size: 14px">通道ID: {{settingCanForm.canid}}</span>
        <el-form-item style="margin-top: 20px">
          <el-select v-model="settingCanForm.mode" placeholder="请选择模式">
            <el-option v-for="(item, index) in modeArr"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="settingCanForm.baudRate" placeholder="请选择波特率">
            <el-option
              v-for="(item, index) in baudRateArr"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="settingCanForm.canFd">
          <el-input v-model="settingCanForm.dataBaudRate" placeholder="请输入波特率" style="width: 217px">
            <template slot="append">Kbps</template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="settingCanForm.isPlay">是否录制</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="settingCanDialogVis = false">取 消</el-button>
        <el-button type="primary" @click="settingCANSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 添加DBC、A2L或UDS文件 -->
    <el-dialog :title="getUploadDialogTitle()"
               :visible.sync="addFileDialogVis"
               width="400px"
               top="30vh">
      <el-upload
        action="/"
        class="upload-demo"
        drag
        :limit="1"
        :on-exceed="handleExceed"
        ref="uploadFileCmp"
        :http-request="uploadNodeFile">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          <div>将文件拖到此处，或<em>点击上传</em></div>
          <div>支持扩展名{{ uploadNode === PROJECT_NODE_TYPE.DBC_ROOT ? '.dbc' : (uploadNode === PROJECT_NODE_TYPE.A2L_ROOT?
            '.zip或.xls .xlsx' : '.xls或.xlsx') }}
          </div>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelUpload">取 消</el-button>
        <el-button type="primary" :disabled="!canUpload" @click="uploadFile">确 定</el-button>
      </div>
    </el-dialog>
    <!--  a2l文件分页-->
    <el-dialog class="a2l-list" title="A2L文件列表" :visible.sync="dialogTableVisible">
      <div>
        <div style="height: 60px;margin: 0 20px">
          <el-switch
            v-model="isCalibration"
            active-text="标定量"
            inactive-text="观测量"
            style="float: left;height: 40px">
          </el-switch>
          <div style="float: right">
            <el-input
              style="width: 35vh;margin-left: 23vh;"
              placeholder="请输入数据源关键词"
              @change="Lok"
              v-model="a2lKeyword"
              clearable>
            </el-input>
            <el-button icon="el-icon-search" circle type="primary" @click="Lok" style="margin-left: 10px"></el-button>
          </div>
        </div>
        <el-transfer class="transfer" style="width: 100%;display: flex;justify-content: center" v-model="a2lValueList"
                     :data="detail" :titles="['数据源', '当前页已选定值']">
          <el-button class="transfer-footer" slot="right-footer" icon="el-icon-plus" size="small" type="primary"
                     @click="pushToOborOC()" round>添加
          </el-button>
        </el-transfer>
        <el-pagination
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          :page-size="100"
          :pager-count="5"
          layout="total, prev, pager, next, jumper"
          :total="allA2LFileLength"
          style="text-align: center;margin: 20px 0;">
        </el-pagination>
      </div>
      <el-card class="box-card" :body-style="{height:'200px',overflow:'auto'}">
        <div slot="header">
          <span style="font-size: 16px">当前{{isCalibration?'标定量':'观测量'}}已选中文件</span>
          <el-button style="float: right" size="small" type="danger" icon="el-icon-delete" @click="ClearChosedData()"
                     round>清空
          </el-button>
          <el-button style="float: right;margin-right: 10px" icon="el-icon-document-checked" @click="CommitChosedData()"
                     size="small" type="primary" round>保存
          </el-button>
        </div>
        <div style="width: 50%;float: left">
          <div v-if="this.isCalibration">
            <div style="margin-left: 5px;margin-bottom: 5px;font-size: 14px" v-for="(j,index) in Ob" :key="j.key"
                 v-if="index%2===0">{{j.key}}<i class="el-icon-delete" style="margin-left: 20px"
                                                @click="deleteKey(j.key)"></i></div>
          </div>
          <div v-else>
            <div style="margin-left: 5px;margin-bottom: 5px;font-size: 14px" v-for="(i,index) in Oc"
                 v-if="index%2===0"
                 :key="i.key">{{i.key}}
              <i class="el-icon-delete" style="margin-left: 10px" @click="deleteKey(i.key)"></i></div>
          </div>
        </div>
        <div style="width: 50%;float: right">
          <div v-if="this.isCalibration">
            <div style="margin-left: 5px;margin-bottom: 5px;font-size: 14px" v-for="(j,index) in Ob" :key="j.key"
                 v-if="index%2!==0">{{j.key}}<i class="el-icon-delete" style="margin-left: 20px"
                                                @click="deleteKey(j.key)"></i></div>
          </div>
          <div v-else>
            <div style="margin-left: 5px;margin-bottom: 5px;font-size: 14px" v-for="(i,index) in Oc"
                 v-if="index%2!==0"
                 :key="i.key">{{i.key}}
              <i class="el-icon-delete" style="margin-left: 10px" @click="deleteKey(i.key)"></i></div>
          </div>
        </div>
      </el-card>
    </el-dialog>
    <!--    a2l文件分组-->
    <el-dialog title="A2L文件分组列表" :visible.sync="dialogFormVisible">
    </el-dialog>
  </div>
</template>
<script>
import { PROJECT_NODE_TYPE, CAN_TYPE } from '@/common/enums';
import projectDetailApi from '@/api/projectDetail';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { buildDB } from '@/utils/utilFun';
import deviceAPI from '@/api/device';
import request from '../../utils/request';
// 测试用的api，正式版删除
// import deviceAPI from '@/api/test';


export default {
  data() {
    return {
      // 标定量
      Ob: [],
      // 观测量
      Oc: [],
      allA2LFileLength: 1,
      // 每次保存can的ID值
      canID: '',
      currentPage: 1,
      // a2lKeyword是搜索值
      a2lKeyword: '',
      // isCalibration false是观测量 true是标定量
      isCalibration: false,
      // a2lValueList a2l文件列表中的选中列表值
      a2lValueList: [],
      // detail a2l所有穿梭框数据列表
      detail: [],
      dialogTableVisible: false,
      dialogFormVisible: false,
      IsExpandAll: false,
      // 控制是否打开树状图
      projectId: -1,
      // 刷新树控制器
      refreshTree: false,
      /**
         * 用于树节点的计算过程中的缓存
         */
      cachedTreeNodeData: {},
      // 设备编辑是否显示
      deviceConfigShow: {},
      PROJECT_NODE_TYPE,
      addCanInput: [],
      // 被过滤的字符串
      filterText: '',
      treeDisplayProps: {
        label: 'text',
        children: 'children',
      },
      singleBindValue: false, // 默认为工作页，之后要修改，因为有多个通道
      canSwitchValue: false, // 参考页为0，refer  工作页为1 job
      modeArr: [
        { label: '正常模式', value: 0 },
        { label: '只听模式', value: 1 },
      ],
      baudRateArr: [
        { label: '5Kbps', value: '5' },
        { label: '10Kbps', value: '10' },
        { label: '20Kbps', value: '20' },
        { label: '40Kbps', value: '40' },
        { label: '50Kbps', value: '50' },
        { label: '80Kbps', value: '80' },
        { label: '100Kbps', value: '100' },
        { label: '125Kbps', value: '125' },
        { label: '200Kbps', value: '200' },
        { label: '250Kbps', value: '250' },
        { label: '400Kbps', value: '400' },
        { label: '500Kbps', value: '500' },
        { label: '666Kbps', value: '666' },
        { label: '800Kbps', value: '800' },
        { label: '1000Kbps', value: '1000' },
      ],
      settingCanDialogVis: false,
      settingCanForm: {},
      // 是否显示添加设备的窗口
      addDeviceDialogVis: false,
      // 配置cascader
      addCanProps: {
        value: 'index',
        label: 'text',
        children: 'canList',
        disabled: 'used',
      },
      // 设备和通道的级联值 [deviceId, canid]
      deviceCanArr: [],
      uploadNode: '',
      // 上传节点的父节点，上传需要此节点信息
      uploadNodeParent: {},
      addFileDialogVis: false,
      // 是否允许上传
      canUpload: false,
      // 检验允许上传后台返回的path
      updateLoading: {},
      uploadPath: '',
      // 配置a2l对话框
      settingA2LDialogVis: false,
      a2lTableLoading: false,
    };
  },
  computed: {
    ...mapState('Engineering', ['leftStructure', 'deviceListOptions', 'a2lBindEventData', 'canBindSingleBind', 'anchorPointId', 'treeDatabase']),
    ...mapGetters('Engineering', ['filterLeftStructure', 'getCurCmpStatus', 'getAllTreeNodeList', 'getAnchorKeyWord']),
    panelStatus() {
      return this.$store.state.Engineering.curPanelStatus;
    },
    a2lCheckArr: {
      get() {
        return JSON.parse(JSON.stringify(this.a2lBindEventData.data));
      },
      set(newValue) {
        return newValue;
      },
    },
    treeData() {
      const self = this;
      this.leftStructure.forEach((item) => {
        const key = item.id;
        if (!self.deviceConfigShow[key]) {
          self.deviceConfigShow[key] = false;
        }
      });
      // TODO:(Qka, 2019/3/11) 在这里可以把一些重要的子节点中加入deviceId的字段，方便树遍历时查找
      return !this.refreshTree ? this.leftStructure : [];
    },
    treeConfigData() {
      const dataList = this.$store.state.Engineering.treeConfigData;
      if (dataList.length > 0) {
        return dataList;
      }
      // 仅用来测试 or 应对特殊情况？
      const treeData = this.leftStructure;
      let returnData = [];
      returnData = treeData.map((dataItem) => {
        const autoStart = false;
        const segmentLength = 1;
        const deviceId = dataItem.id;
        const events = ['XcpEvent1000', 'XcpEvent100', 'XcpEvent20', 'XcpEvent10'];
        const lData = buildDB([dataItem]);
        const targetList = [];
        const canConfigs = [];
        for (const i in lData) {
          if (lData[i].type === PROJECT_NODE_TYPE.DBC_MSG || lData[i].type === PROJECT_NODE_TYPE.A2L_MEASURE) {
            targetList.push(lData[i]);
          } else if (lData[i].type === PROJECT_NODE_TYPE.CAN) {
            canConfigs.push({ canProjectConfigId: lData[i].id, play: true });
          }
        }
        const targets = targetList.map((item) => {
          const key = item.id;
          const enabled = false;
          const interval = 1;
          const event = 'XcpEvent1000';
          const cycle = '100ms';
          return {
            key, enabled, interval, event, cycle,
          };
        });
        return {
          autoStart,
          segmentLength,
          deviceId,
          targets,
          canConfigs,
          events,
        };
      });
      return returnData;
    },
    allTreeNodeList: {
      get() {
        const length = this.getAllTreeNodeList.length;
        if (length > 1) {
          const list = this.getAllTreeNodeList.substring(1, length).split('!');
          return list;
        }
        return [];
      },
      set(newValue) {
        return newValue;
      },
    },
  },
  watch: {
    isCalibration: {
      handler(newItem) {
        this.dialogTableVisibleshow();
      },
      immediate: true,
      deep: true,
    },
    // 监听锚点key的变化，匹配到id则执行锚点跳转
    anchorPointId(newId, oldId) {
      if (oldId !== '') {
        $(`#${oldId}`)
          .css('color', 'black');
      }
      if (newId === '') {
        return;
      }
      const keyList = Object.keys(this.treeDatabase);
      const index = keyList.findIndex((item) => {
        const arr = item.split('.');
        const str = arr.join('');
        const arr2 = str.split(':');
        const str2 = arr2.join('');
        return newId === str2;
      });
      if (index > -1) {
        const $dom = $(`#${newId}`);
        const $left = $('.left-aside');
        $left.animate({ scrollTop: 0 }, 0);
        $left.animate({ scrollTop: $dom.offset().top - 400 }, 500);
        $dom.css('color', 'RGB(255,150,50)');
      }
    },
    // 监听被过滤的值
    filterText(val) {
      if (val !== null) {
        val = val.replace(/^\s+|\s+$/g, '');
      }
      this.$refs.leftTree.filter(val);
    },
    panelStatus: {
      handler(newItem) {
      },
      immediate: true,
    },
    getAnchorKeyWord() {
      this.filterText = this.getAnchorKeyWord;
    },
    // 波特率值输入检查
    settingCanForm: {
      handler() {
        const num = /^\d+$/;
        if (!num.test(this.settingCanForm.dataBaudRate)) {
          this.$message({
            message: '请输入正确的波特率数值！',
            type: 'warning',
          });
          this.settingCanForm.dataBaudRate = '0';
        } else if (this.settingCanForm.dataBaudRate > 8000) {
          this.$message({
            message: '波特率最大值为8000Kbps，请重新输入！',
            type: 'warning',
          });
          this.settingCanForm.dataBaudRate = '8000';
        } else if (this.settingCanForm.dataBaudRate < 0) {
          this.$message({
            message: '波特率最小值为0Kbps，请重新输入！',
            type: 'warning',
          });
          this.settingCanForm.dataBaudRate = '0';
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.allTreeNodeList = this.$store.state.Engineering.allTreeNodeList;
    this.getTreeData();
    this.projectId = this.$route.params.id;
  },
  methods: {
    ...mapMutations('Engineering', ['setDisplayType', 'setDragNodeType', 'setDragTreeNodeKey', 'setAnchorPointId', 'setAllTreeNodeList']),
    ...mapActions('Engineering', [
      'getLeftStructure',
      'getDeviceListOptions',
      'addDevice',
      'settingCan',
      'projectUploadFile',
      'projectAddNodeFile',
      'getA2LBindEventData',
      'a2lBindEvent',
      'switchPageOfCan',
      'getCanConfig', 'getTreeConfigData',
      'saveTreeConfigData',
      'configToDevice',
      'deleteDevice',
      'getInitPanelData']),
    // 删除选中a2l列表值
    deleteKey(key) {
      if (this.isCalibration) {
        this.Ob.splice(this.Ob.findIndex(item => item.key === key), 1);
      } else {
        this.Oc.splice(this.Oc.findIndex(item => item.key === key), 1);
      }
    },
    Lok() {
      this.currentPage = 1;
      this.handleCurrentChange(1);
    },
    handleCurrentChange(curPage) {
      const type = this.isCalibration ? 2 : 1;
      deviceAPI.getAllA2l(this.canID, curPage, type, this.a2lKeyword).then(
        (res) => {
          // 返回所有数据
          this.detail = res.data;
          if (this.isCalibration) {
            // 标定量
            this.Ob = res.savedData;
          } else {
            // 观测量
            this.Oc = res.savedData;
          }
          // 接受分页数据长度每页100条
          this.allA2LFileLength = res.totalConn;
        },
      ).catch();
    },
    // 放到总提交文件列表里
    pushToOborOC() {
      if (this.isCalibration) {
        this.a2lValueList.map((res) => {
          if (this.Ob.findIndex(item => item.key === res) === -1) {
            this.Ob.push({ key: res });
          }
        });
      } else {
        this.a2lValueList.map((res) => {
          if (this.Oc.findIndex(item => item.key === res) === -1) {
            this.Oc.push({ key: res });
          }
        });
      }
    },
    // 清除所有提交值
    ClearChosedData() {
      if (this.isCalibration) {
        this.Ob = [];
      } else {
        this.Oc = [];
      }
    },
    // 提交当前的选中a2l值
    CommitChosedData() {
      // console.log('valueList', this.a2lValueList);
      // 2是标定量，1是观测量
      const type = this.isCalibration ? 2 : 1;
      // vaule1为true是Ob是标定量false为Oc是观测量
      const sendValue = this.isCalibration ? this.Ob.map(res => res.key) : this.Oc.map(res => res.key);
      const self = this;
      deviceAPI.commitA2lChosedFileList(this.canID, sendValue, type).then((res) => {
        if (sendValue.length > 0) {
          self.$message({ message: '添加成功，请在页面查看！', type: 'success' });
        } else {
          self.$message.warning('已清除所有值');
        }
        self.getTreeData();
      }).catch((err) => {
        self.$message.error(`配置失败${err[1]}(${err[0]})`);
      });
    },
    //  请求a2l分页页面和数据传设备id，can口id ，信号量还是观测量id，页面id
    dialogTableVisibleshow(CanID) {
      this.a2lKeyword = null;
      // 判断是否有CanID
      if (CanID !== undefined) {
        this.canID = CanID;
      } else {
        if (this.canID === '') {
          return;
        }
        CanID = this.canID;
      }
      const PageID = this.currentPage;
      // 查看当前值状态
      const type = this.isCalibration ? 2 : 1;
      // 显示a2l选择框
      deviceAPI.getAllA2l(CanID, PageID, type, this.a2lKeyword).then(
        (res) => {
          if (res.data.length === 0) {
            this.$message.info('通道未绑定A2L文件');
            return;
          }
          this.a2lValueList = [];
          this.dialogTableVisible = true;
          // 返回所有数据
          this.detail = res.data;

          if (this.isCalibration) {
            // 标定量
            this.Ob = res.savedData;
          } else {
            // 观测量
            this.Oc = res.savedData;
          }
          // 接受分页数据长度每页100条
          this.allA2LFileLength = res.totalConn;
        },
      ).catch((err) => {
        console.log('a2l文件可能未导入');
      });
    },
    addTreeNodeList(Ob) {
      console.log(Ob);
      if (Ob.id) {
        const nodeList = `${this.getAllTreeNodeList}!${Ob.id.toString()}`;
        this.setAllTreeNodeList(nodeList);
      }
    },
    deleteTreeNodeList(Ob) {
      console.log(Ob);
      if (Ob.id) {
        const key = `!${Ob.id.toString()}`;
        const nodeList = this.getAllTreeNodeList.replace(key, '');
        this.setAllTreeNodeList(nodeList);
      }
    },
    /**
       * 过滤左侧的节点
       * @param value
       * @param data
       * @return {boolean}
       */
    filterNode(value, data) {
      if (!value) return true;
      // 不展开Signal节点下的信号
      if (data.alone === true) {
        return false;
      }
      const show = data.text.toLowerCase()
        .indexOf(value.toLowerCase()) !== -1;
      return show;
    },
    getUploadDialogTitle() {
      return `添加${this.uploadNode === PROJECT_NODE_TYPE.DBC_ROOT ? 'DBC' : (this.uploadNode === PROJECT_NODE_TYPE.A2L_ROOT ? '导入excel或对A2l描述的Excel' : 'UDS')}`;
    },
    getTreeData() {
      const { id: projectId } = this.$route.params;
      this.getLeftStructure({ projectId });
      this.getTreeConfigData({ projectId })
        .then((s) => {
        })
        .catch((e) => {
        });
    },
    /**
       * 使树进行刷新
       */
    doRefreshTree() {
      this.refreshTree = true;
      setTimeout(() => {
        this.refreshTree = false;
      }, 1);
    },
    // 点击筛选显示的内容(dbc/a2l)
    displayDetailType(type) {
      this.setDisplayType({ type });
    },
    addDeviceClick() {
      this.getDeviceListOptions({ projectId: this.$route.params.id });
      this.addDeviceDialogVis = true;
    },
    /**
       * 点击mdf配置同步按钮
       */
    mdfConfigUpdateClick() {
      const { id: projectId } = this.$route.params;
      projectDetailApi.downloadMDFConfigToDeviceAll(projectId)
        .then(() => {
          this.$message({
            message: '同步MDF配置成功',
            type: 'success',
          });
        })
        .catch((err) => {
          this.$message({
            message: `同步MDF配置失败${err[1]}`,
            type: 'error',
          });
        });
    },
    /**
       * 得到树节点的父亲，向上查找，直到level相等
       */
    getTreeNodeParent(curNode, targetLevel) {
      const { cachedNode, cachedLevel, cachedResult } = this.cachedTreeNodeData;
      if (cachedNode !== null && cachedNode === curNode && cachedLevel === targetLevel) {
        // console.debug('使用缓存结果');
        // console.debug(cachedResult);
        return cachedResult;
      }
      let result = null;
      let { parent } = curNode;
      // 递归找到level=1即设备一级
      while (parent !== null) {
        if (parent.level === targetLevel) {
          result = parent;
          break;
        }
        parent = parent.parent;
      }
      if (result !== null) {
        // 加入缓存
        this.cachedTreeNodeData.cachedNode = curNode;
        this.cachedTreeNodeData.cachedResult = result;
        this.cachedTreeNodeData.cachedLevel = targetLevel;
      }
      return result;
    },
    renderTreeContent(h, { node, data }) {
      const self = this;
      // const type = data.text.length > 3 ? data.text.slice(0, 3).toUpperCase() : data.text.slice(0).toUpperCase();
      const nodeType = data.type;
      const hasSettingArray = [PROJECT_NODE_TYPE.A2L_ROOT, PROJECT_NODE_TYPE.CAN, PROJECT_NODE_TYPE.DBC_ROOT, PROJECT_NODE_TYPE.UDS_ROOT];
      if (hasSettingArray.includes(nodeType)) {
        if (nodeType === PROJECT_NODE_TYPE.CAN) {
          // CAN节点
          const a2lChild = data.children ? data.children.filter(item => item.text.toUpperCase() === 'A2L')[0] : {};
          // 有A2L文件的话
          if (a2lChild.children && a2lChild.children.length) {
            return h('span', {
              class: ['custom-tree-node'],
            }, [
              h('span', {}, [
                h('span', {}, [
                  h('Icon', {
                    attrs: {
                      type: 'md-git-network',
                    },
                  }),
                ]),
                h('span', {
                  class: ['custom-label'],
                  on: {
                    dragstart: event => this.treeDrag(event, node, data),
                  },
                  attrs: {
                    draggable: true,
                  },
                  domProps: {
                    innerHTML: node.label,
                  },
                }),
              ]),
              h('span', {}, [
                h('span', {
                  style: {
                    marginLeft: '10px',
                  },
                }, [
                  // h('el-switch', {
                  //   props: {
                  //     value: this.canSwitchValue,
                  //   },
                  //   on: {
                  //     change: event => this.switchCan(event, node, data),
                  //   },
                  //   style: {
                  //     display: self.panelStatus === true ? 'inline-block' : 'none',
                  //   },
                  // }),
                  h('el-tooltip', {
                    class: 'item',
                    props: {
                      effect: 'dark',
                      content: '配置',
                      placement: 'top',
                    },
                    style: {
                      marginLeft: '10px',
                    },
                  }, [
                    h('i', {
                      class: 'el-icon-s-tools',
                      on: {
                        click: () => this.treeLeafSetting(node, data),
                      },
                    }, []),
                  ]),
                ]),
              ]),
            ]);
          }
          return h('span', {
            class: ['custom-tree-node'],
          }, [
            h('span', {}, [
              h('span', {}, [
                h('Icon', {
                  attrs: {
                    type: 'md-git-network',
                  },
                }),
              ]),
              h('span', {
                class: ['custom-label'],
                on: {
                  dragstart: event => this.treeDrag(event, node, data),
                },
                attrs: {
                  draggable: true,
                },
                domProps: {
                  innerHTML: node.label,
                },
              }, []),
            ]),
            h('span', {}, [
              h('span', {
                style: {
                  marginLeft: '10px',
                },
              }, [
                h('el-tooltip', {
                  class: 'item',
                  props: {
                    effect: 'dark',
                    content: '配置',
                    placement: 'top',
                  },
                  style: {
                    marginLeft: '10px',
                  },
                }, [
                  h('i', {
                    class: 'el-icon-s-tools',
                    on: {
                      click: () => this.treeLeafSetting(node, data),
                    },
                  }),
                ]),
              ]),
            ]),
          ]);
        }
        if (nodeType === PROJECT_NODE_TYPE.A2L_ROOT) {
          if (node.childNodes[0].childNodes.length + node.childNodes[1].childNodes.length > 0) {
            this.getA2LBindEventData(node.parent.data.id);
          }
          return h('span', {
            class: ['custom-tree-node'],
          }, [
            h('span', {}, [
              h('span', {}, [
                h('Icon', {
                  attrs: {
                    type: 'md-navigate',
                  },
                }),
              ]),
              h('span', {
                class: ['custom-label'],
                on: {
                  dragstart: event => this.treeDrag(event, node, data),
                },
                attrs: {
                  draggable: true,
                },
                domProps: {
                  innerHTML: node.label,
                },
              }),
            ]),
            h('span', {}, [
              h('span', {
                style: {
                  marginLeft: '10px',
                },
              }, [
                h('el-tooltip', {
                  class: 'item',
                  props: {
                    effect: 'dark',
                    content: '导入a2l相关文件',
                    placement: 'top',
                  },
                }, [
                  h('i', {
                    class: 'el-icon-plus',
                    on: {
                      click: (event) => {
                        // 阻止冒泡
                        event.stopPropagation();
                        this.treeLeafAdd(node, data);
                      },
                    },
                  }),
                ]),
              ]),
              h('span', {
                style: {
                  marginLeft: '10px',
                },
              }, [
                h('el-tooltip', {
                  class: 'item',
                  props: {
                    effect: 'dark',
                    content: '选择观看A2L',
                    placement: 'top',
                  },
                }, [
                  h('i', {
                    class: 'el-icon-view',
                    on: {
                      // 第一个值是canID，第二个值是设备iD
                      click: (event) => {
                        // 阻止冒泡
                        event.stopPropagation();
                        this.dialogTableVisibleshow(node.parent.data.id);
                      },
                    },
                  }),
                ]),
              ]),
            ]),
          ]);
        }
        if (nodeType === PROJECT_NODE_TYPE.DBC_ROOT) {
          return h('span', {
            class: ['custom-tree-node'],
          }, [
            h('span', {}, [
              h('span', {}, [
                h('Icon', {
                  attrs: {
                    type: 'ios-information-circle',
                  },
                }),
              ]),
              h('span', {
                class: ['custom-label'],
                on: {
                  dragstart: event => this.treeDrag(event, node, data),
                },
                attrs: {
                  draggable: true,
                },
                domProps: {
                  innerHTML: node.label,
                },
              }),
            ]),
            h('span', {}, [
              h('span', {
                style: {
                  marginLeft: '10px',
                },
              }, [
                h('el-tooltip', {
                  class: 'item',
                  props: {
                    effect: 'dark',
                    content: '新增',
                    placement: 'top',
                  },
                }, [
                  h('i', {
                    class: 'el-icon-plus',
                    on: {
                      click: (event) => {
                        // 阻止冒泡
                        event.stopPropagation();
                        this.treeLeafAdd(node, data);
                      },
                    },
                  }),
                ]),
              ]),
            ]),
          ]);
        }
        if (nodeType === PROJECT_NODE_TYPE.UDS_ROOT) {
          return h('span', {
            class: ['custom-tree-node'],
          }, [
            h('span', {}, [
              h('span', {}, [
                h('Icon', {
                  attrs: {
                    type: 'md-medical',
                  },
                }),
              ]),
              h('span', {
                class: ['custom-label'],
                on: {
                  dragstart: event => this.treeDrag(event, node, data),
                },
                attrs: {
                  draggable: true,
                },
                domProps: {
                  innerHTML: node.label,
                },
              }),
            ]),
            h('span', {}, [
              h('span', {
                style: {
                  marginLeft: '10px',
                },
              }, [
                h('el-tooltip', {
                  class: 'item',
                  props: {
                    effect: 'dark',
                    content: '新增',
                    placement: 'top',
                  },
                }, [
                  h('i', {
                    class: 'el-icon-plus',
                    on: {
                      click: (event) => {
                        // 阻止冒泡
                        event.stopPropagation();
                        this.treeLeafAdd(node, data);
                      },
                    },
                  }),
                ]),
              ]),
            ]),
          ]);
        }
      }
      return h('span', {
        class: ['custom-tree-node'],
        // 图标+名称+设置
        style: {
          display: 'flex',
          'align-items': 'center',
          height: 'auto',
        },
        attrs: {
          id: (() => {
            const { id = '' } = data;
            const arr = id.split('.');
            const str = arr.join('');
            const arr2 = str.split(':');
            return arr2.join('');
          })(),
        },
      }, [
        // 图标+名称
        h('span', {
          style: {
            display: 'flex',
            'align-items': 'center',
          },
        }, [
          h('span', {}, [
            // 图标
            h('Icon', {
              attrs: {
                type: (() => {
                  if (nodeType === PROJECT_NODE_TYPE.DEVICE) {
                    return 'md-easel';
                  } else if (nodeType === PROJECT_NODE_TYPE.DEVICE_HW) {
                    return 'md-git-commit';
                  } else if (nodeType === PROJECT_NODE_TYPE.SYSTEM_VARIABLES) {
                    return 'ios-analytics';
                  } else if (nodeType === PROJECT_NODE_TYPE.DBC_SIGNAL ||
                      nodeType === PROJECT_NODE_TYPE.A2L_MEASURE ||
                      nodeType === PROJECT_NODE_TYPE.A2L_CHARACTER) {
                    return 'md-link';
                  } else if (nodeType === PROJECT_NODE_TYPE.DBC_MSG) {
                    return 'md-ionic';
                  } else if (nodeType === PROJECT_NODE_TYPE.DBC_TIME) {
                    return 'md-time';
                  } else if (nodeType === PROJECT_NODE_TYPE.DBC_TRIGGER) {
                    return 'md-checkbox-outline';
                  }
                  return 'md-list-box';
                })(),
              },
              style: {
                display: 'inline-block',
                width: '12px',
                height: '12px',
              },
            }),
          ]),
          // 名称外的span
          h('span', {
            class: ['custom-label'],
            on: {
              dragstart: event => this.treeDrag(event, node, data),
            },
            attrs: {
              draggable: true,
            },
            domProps: {},
            style: {
              overflow: 'hidden',
              display: 'flex',
              'flex-direction': 'column ',
            },
          }, [
            // 名称
            h('div', {
              attrs: {
                // 给每个节点绑定id，用于锚点跳转
                id: (() => {
                  const { id = '' } = data;
                  const arr = id.split('.');
                  const str = arr.join('');
                  const arr2 = str.split(':');
                  return arr2.join('');
                })(),
              },
              domProps: {
                innerHTML: node.label,
              },
              style: {
                width: (() => (this.deviceConfigShow[data.id] ? '100%' : '100%'))(),
                overflow: 'hidden',
                'white-space': 'noWrap',
                'text-overflow': 'ellipsis',
              },
            }),
            // 设备设置界面
            h('div', {
              style: {
                display: (() => (nodeType === PROJECT_NODE_TYPE.DEVICE ? 'inline' : 'none'))(),
              },
            }, [
              h('span', {
                class: 'dom_flex',
                domProps: {
                  innerHTML: '',
                },
                style: {
                  display: (() => (this.deviceConfigShow[data.id] ? 'inline-block' : 'none'))(),
                },
              }),
              // 设备默认打开标签
              h('input', {
                style: {
                  marginRight: '5px',
                  display: (() => (this.deviceConfigShow[data.id] ? 'inline-block' : 'none'))(),
                },
                on: {
                  click: (e) => {
                    e.stopPropagation();
                    console.log(this);
                    const deviceIndex = this.treeConfigData.findIndex(deviceItem => deviceItem.deviceId === data.id);
                    if (deviceIndex > -1) {
                      this.treeConfigData[deviceIndex].autoStart = e.target.checked;
                    }
                  },
                },
                attrs: {
                  type: 'checkbox',
                  checked: (() => {
                    const deviceIndex = this.treeConfigData.findIndex(item => item.deviceId == data.id);
                    if (deviceIndex > -1) {
                      return this.treeConfigData[deviceIndex].autoStart;
                    }
                    return false;
                  })(),
                },
              }),
              h('span', {
                domProps: {
                  innerHTML: '自动启动',
                },
                style: {
                  marginTop: '5px',
                  display: (() => (this.deviceConfigShow[data.id] ? 'inline-block' : 'none'))(),
                },
              }),
              h('span', {
                domProps: {
                  innerHTML: (() => {
                    const index = this.treeConfigData.findIndex(item => item.deviceId == data.id);
                    if (index > -1) {
                      return '分段长度：';
                    }
                    return '';
                  })(),
                },
                style: {
                  marginTop: '5px',
                  marginLeft: '10px',
                  display: (() => (this.deviceConfigShow[data.id] ? 'inline-block' : 'none'))(),
                },
              }),
              // 编辑分段长度
              h('input', {
                style: {
                  marginTop: '5px',
                  display: (() => (this.deviceConfigShow[data.id] ? 'inline-block' : 'none'))(),
                  width: '40px',
                  height: '15px',
                },
                attrs: {
                  type: 'number',
                  min: 1,
                  max: 100,
                  value: (() => {
                    const index = this.treeConfigData.findIndex(item => item.deviceId == data.id);
                    if (index > -1) {
                      return this.treeConfigData[index].segmentLength;
                    }
                    return '';
                  })(),
                },
                on: {
                  click: (e) => {
                    e.stopPropagation();
                  },
                  input: (newValue) => {
                    const deviceIndex = this.treeConfigData.findIndex(item => item.deviceId === data.id);
                    this.treeConfigData[deviceIndex].segmentLength = newValue.target.value;
                  },
                },
              }, []),
              h('span', {
                domProps: {
                  innerHTML: 'MB',
                },
                style: {
                  marginTop: '5px',
                  display: (() => (this.deviceConfigShow[data.id] ? 'inline-block' : 'none'))(),
                },
              }),
              h('p', {}, [
                // h('input', {
                //   style: {
                //     marginTop: '5px',
                //     display: (() => (this.deviceConfigShow[data.id] ? 'inline-block' : 'none'))(),
                //   },
                //   on: {
                //     click: (e) => {
                //       e.stopPropagation();
                //       console.log(this);
                //       const deviceIndex = this.treeConfigData.findIndex(deviceItem => deviceItem.deviceId === data.id);
                //       if (deviceIndex > -1) {
                //         this.treeConfigData[deviceIndex].playAsc = e.target.checked;
                //         console.log(this.treeConfigData);
                //       }
                //     },
                //   },
                //   attrs: {
                //     type: 'checkbox',
                //     checked: (() => {
                //       const deviceIndex = this.treeConfigData.findIndex(item => item.deviceId === data.id);
                //       if (deviceIndex > -1) {
                //         return this.treeConfigData[deviceIndex].playAsc;
                //       }
                //       return false;
                //     })(),
                //   },
                // }),
                //
                //----------
                // h('input', {
                //   style: {
                //     marginTop: '5px',
                //     display: (() => (this.deviceConfigShow[data.id] ? 'inline-block' : 'none'))(),
                //   },
                //   on: {
                //     click: (e) => {
                //       e.stopPropagation();
                //       console.log(this);
                //       const deviceIndex = this.treeConfigData.findIndex(deviceItem => deviceItem.deviceId === data.id);
                //       if (deviceIndex > -1) {
                //         this.treeConfigData[deviceIndex].playAsc = e.target.checked;
                //         console.log(this.treeConfigData);
                //       }
                //     },
                //   },
                //   attrs: {
                //     type: 'checkbox',
                //     checked: (() => {
                //       const deviceIndex = this.treeConfigData.findIndex(item => item.deviceId == data.id);
                //       if (deviceIndex > -1) {
                //         return this.treeConfigData[deviceIndex].playAsc;
                //       }
                //       return false;
                //     })(),
                //   },
                // }),
                // h('p', {
                //   domProps: {
                //     innerHTML: 'playAsc',
                //   },
                //   style: {
                //     margin: '5px',
                //     display: (() => (this.deviceConfigShow[data.id] ? 'inline-block' : 'none'))(),
                //   },
                // }),

                // 测试代码
                h('select', {
                  attrs: {
                    name: 'event-select',
                  },
                  on: {
                    click: (e) => {
                      e.stopPropagation();
                    },
                    change: (newValue) => {
                      console.log(this);
                      const deviceIndex = this.treeConfigData.findIndex(deviceItem => deviceItem.deviceId === data.id);
                      if (deviceIndex > -1) {
                        if (newValue.target.value == 'Rec All Asc') {
                          this.treeConfigData[deviceIndex].recAllAsc = true;
                          this.treeConfigData[deviceIndex].recAscByDbc = false;
                        } else if (newValue.target.value == 'Rec Asc By DBC') {
                          this.treeConfigData[deviceIndex].recAllAsc = false;
                          this.treeConfigData[deviceIndex].recAscByDbc = true;
                        } else {
                          this.treeConfigData[deviceIndex].recAllAsc = false;
                          this.treeConfigData[deviceIndex].recAscByDbc = false;
                        }
                      }
                    },
                  },
                  style: {
                    marginRight: '5px',
                    width: '100px',
                    display: (() => (this.deviceConfigShow[data.id] ? 'inline-block' : 'none'))(),
                  },
                }, [
                  h('option', {
                    attrs: {
                      selected: (() => {
                        const deviceIndex = this.treeConfigData.findIndex(deviceItem => deviceItem.deviceId === data.id);
                        if (deviceIndex > -1) {
                          return this.treeConfigData[deviceIndex].recAllAsc === false && this.treeConfigData[deviceIndex].recAscByDbc === false;
                        }
                        return false;
                      })(),
                    },
                    domProps: {
                      innerHTML: '暂无ASC配置',
                    },
                  }),
                  h('option', {
                    attrs: {
                      selected: (() => {
                        const deviceIndex = this.treeConfigData.findIndex(deviceItem => deviceItem.deviceId === data.id);
                        if (deviceIndex > -1) {
                          return this.treeConfigData[deviceIndex].recAllAsc === true && this.treeConfigData[deviceIndex].recAscByDbc === false;
                        }
                        return false;
                      })(),
                    },
                    domProps: {
                      innerHTML: 'Rec All Asc',
                    },
                  }),
                  h('option', {
                    attrs: {
                      selected: (() => {
                        const deviceIndex = this.treeConfigData.findIndex(deviceItem => deviceItem.deviceId === data.id);
                        if (deviceIndex > -1) {
                          return this.treeConfigData[deviceIndex].recAllAsc === false && this.treeConfigData[deviceIndex].recAscByDbc === true;
                        }
                        return false;
                      })(),
                    },
                    domProps: {
                      innerHTML: 'Rec Asc By DBC',
                    },
                  }),
                ]),
                // 测试代码

                h('input', {
                  style: {
                    display: (() => (this.deviceConfigShow[data.id] ? 'inline-block' : 'none'))(),
                  },
                  on: {
                    click: (e) => {
                      e.stopPropagation();
                      console.log(this);
                      const deviceIndex = this.treeConfigData.findIndex(deviceItem => deviceItem.deviceId === data.id);
                      if (deviceIndex > -1) {
                        this.treeConfigData[deviceIndex].playDat = e.target.checked;
                      }
                    },
                  },
                  attrs: {
                    type: 'checkbox',
                    checked: (() => {
                      const deviceIndex = this.treeConfigData.findIndex(item => item.deviceId == data.id);
                      if (deviceIndex > -1) {
                        return this.treeConfigData[deviceIndex].playDat;
                      }
                      return false;
                    })(),
                  },
                }),
                h('p', {
                  domProps: {
                    innerHTML: 'Rec Dat',
                  },
                  style: {
                    margin: '5px',
                    display: (() => (this.deviceConfigShow[data.id] ? 'inline-block' : 'none'))(),
                  },
                }),

                // h('input', {
                //   style: {
                //     marginTop: '5px',
                //     display: (() => (this.deviceConfigShow[data.id] ? 'inline-block' : 'none'))(),
                //   },
                //   on: {
                //     click: (e) => {
                //       e.stopPropagation();
                //       console.log(this);
                //       const deviceIndex = this.treeConfigData.findIndex(deviceItem => deviceItem.deviceId === data.id);
                //       if (deviceIndex > -1) {
                //         this.treeConfigData[deviceIndex].playBlf = e.target.checked;
                //       }
                //     },
                //   },
                //   attrs: {
                //     type: 'checkbox',
                //     checked: (() => {
                //       const deviceIndex = this.treeConfigData.findIndex(item => item.deviceId == data.id);
                //       if (deviceIndex > -1) {
                //         return this.treeConfigData[deviceIndex].playBlf;
                //       }
                //       return false;
                //     })(),
                //   },
                // }),
                // h('p', {
                //   domProps: {
                //     innerHTML: 'playBlf',
                //   },
                //   style: {
                //     margin: '5px',
                //     display: (() => (this.deviceConfigShow[data.id] ? 'inline-block' : 'none'))(),
                //   },
                // }),

                h('select', {
                  attrs: {
                    name: 'event-select',
                  },
                  on: {
                    click: (e) => {
                      e.stopPropagation();
                    },
                    change: (newValue) => {
                      console.log(this);
                      const deviceIndex = this.treeConfigData.findIndex(deviceItem => deviceItem.deviceId === data.id);
                      if (deviceIndex > -1) {
                        if (newValue.target.value == 'Rec All Blf') {
                          this.treeConfigData[deviceIndex].recAllBlf = true;
                          this.treeConfigData[deviceIndex].recBlfByDbc = false;
                        } else if (newValue.target.value == 'Rec Blf By DBC') {
                          this.treeConfigData[deviceIndex].recAllBlf = false;
                          this.treeConfigData[deviceIndex].recBlfByDbc = true;
                        } else {
                          this.treeConfigData[deviceIndex].recAllBlf = false;
                          this.treeConfigData[deviceIndex].recBlfByDbc = false;
                        }
                      }
                    },
                  },
                  style: {
                    marginRight: '5px',
                    width: '100px',
                    display: (() => (this.deviceConfigShow[data.id] ? 'inline-block' : 'none'))(),
                  },
                }, [
                  h('option', {
                    attrs: {
                      selected: (() => {
                        const deviceIndex = this.treeConfigData.findIndex(deviceItem => deviceItem.deviceId === data.id);
                        if (deviceIndex > -1) {
                          return this.treeConfigData[deviceIndex].recAllBlf === false && this.treeConfigData[deviceIndex].recBlfByDbc === false;
                        }
                        return false;
                      })(),
                    },
                    domProps: {
                      innerHTML: '暂无Blf配置',
                    },
                  }),
                  h('option', {
                    attrs: {
                      selected: (() => {
                        const deviceIndex = this.treeConfigData.findIndex(deviceItem => deviceItem.deviceId === data.id);
                        if (deviceIndex > -1) {
                          return this.treeConfigData[deviceIndex].recAllBlf === true && this.treeConfigData[deviceIndex].recBlfByDbc === false;
                        }
                        return false;
                      })(),
                    },
                    domProps: {
                      innerHTML: 'Rec All Blf',
                    },
                  }),
                  h('option', {
                    attrs: {
                      selected: (() => {
                        const deviceIndex = this.treeConfigData.findIndex(deviceItem => deviceItem.deviceId === data.id);
                        if (deviceIndex > -1) {
                          return this.treeConfigData[deviceIndex].recAllBlf === false && this.treeConfigData[deviceIndex].recBlfByDbc === true;
                        }
                        return false;
                      })(),
                    },
                    domProps: {
                      innerHTML: 'Rec Blf By DBC',
                    },
                  }),
                ]),

                h('p', {}, [
                  h('span', {
                    domProps: {
                      innerHTML: 'FileNamePreFix:',
                    },
                    style: {
                      marginRight: '5px',
                      display: (() => (this.deviceConfigShow[data.id] ? 'inline-block' : 'none'))(),
                    },
                  }), h('input', {
                    style: {
                      width: '150px',
                      display: (() => (this.deviceConfigShow[data.id] ? 'inline-block' : 'none'))(),
                    },
                    attrs: {
                      placeholder: '默认前缀为空',
                      value: (() => {
                        const index = this.treeConfigData.findIndex(item => item.deviceId == data.id);
                        if (index > -1) {
                          return this.treeConfigData[index].namePrefix;
                        }
                        return '';
                      })(),
                    },
                    on: {
                      click: (e) => {
                        e.stopPropagation();
                      },
                      input: (newValue) => {
                        const deviceIndex = this.treeConfigData.findIndex(item => item.deviceId === data.id);
                        this.treeConfigData[deviceIndex].namePrefix = newValue.target.value;
                      },
                    },
                  })]),
                h('p', {}, [h('span', {
                  domProps: {
                    innerHTML: 'SigNamePreFix:',
                  },
                  style: {
                    marginRight: '5px',
                    display: (() => (this.deviceConfigShow[data.id] ? 'inline-block' : 'none'))(),
                  },
                }), h('input', {
                  style: {
                    width: '150px',
                    display: (() => (this.deviceConfigShow[data.id] ? 'inline-block' : 'none'))(),
                  },
                  attrs: {
                    placeholder: '默认前缀为空',
                    value: (() => {
                      const index = this.treeConfigData.findIndex(item => item.deviceId == data.id);
                      if (index > -1) {
                        return this.treeConfigData[index].sigPrefix;
                      }
                      return '';
                    })(),
                  },
                  on: {
                    click: (e) => {
                      e.stopPropagation();
                    },
                    input: (newValue) => {
                      const deviceIndex = this.treeConfigData.findIndex(item => item.deviceId === data.id);
                      this.treeConfigData[deviceIndex].sigPrefix = newValue.target.value;
                    },
                  },
                })]),
              ]),
            ]),
          ]),
        ]),
        /**
           * 设备编辑按钮
           */
        h('i', {
          class: 'el-icon-s-tools',
          attrs: {
            type: 'checkbox',
          },
          domProps: {},
          style: {
            display: (() => (nodeType === PROJECT_NODE_TYPE.DEVICE && !this.deviceConfigShow[data.id] ? 'inline' : 'none'))(),
          },
          on: {
            click: (e) => {
              e.stopPropagation();
              const dom = e.target;
              this.deviceConfigShow[data.id] = true;
              this.doRefreshTree();
            },
          },
        }),
        /**
         * DBC删除按钮
         */
        h('i', {
          class: 'el-icon-delete',
          attrs: {
            type: 'checkbox',
            title: '删除',
          },
          domProps: {},
          style: {
            display: (() => (nodeType === 13 ? 'inline' : 'none'))(),
          },
          on: {
            click: (e) => {
              e.stopPropagation();
              const id = data.id;
              projectDetailApi.removeDbc(id)
                .then(() => {
                  this.getTreeData();
                  this.getInitPanelData();
                  this.$message({
                    message: '删除成功',
                    type: 'success',
                  });
                });
            },
          },
        }),
        h('div', {
          class: 'button-group',
          style: {
            display: (() => (this.deviceConfigShow[data.id] ? 'flex' : 'none'))(),
            justifyContent: 'space-between',
            width: '100px',
            marginLeft: '0px',
          },
        }, [
          /**
             * 下发按钮
             */
          h('i', {
            class: 'el-icon-download',
            domProps: {
              innerHTML: '',
            },
            attrs: {
              title: '下发到当前设备',
            },
            on: {
              click: (e) => {
                e.stopPropagation();
                const projectId = this.$route.params.id;
                const deviceId = data.id;
                this.configToDevice({ projectId, deviceId })
                  .then(() => {
                    this.$message({
                      message: '下发成功',
                      type: 'success',
                    });
                  });
              },
            },
          }),
          /**
             * 设备保存按钮
             */
          h('i', {
            class: 'el-icon-circle-check',
            attrs: {
              type: 'checkbox',
              title: '保存',
            },
            domProps: {},
            on: {
              click: (e) => {
                e.stopPropagation();
                const deviceIndex = this.treeConfigData.findIndex(item => item.deviceId === data.id);
                const sendData = this.treeConfigData[deviceIndex];
                const pattern = /[\\/:\\*\\?"<>|]/;
                if (pattern.test(sendData.namePrefix)) {
                  this.$message({
                    message: '前缀中包含非法字符',
                    type: 'error',
                  });
                  return;
                }
                sendData.projectId = this.$route.params.id;
                this.saveTreeConfigData(sendData)
                  .then(() => {
                    this.$message({
                      message: '保存成功',
                      type: 'success',
                    });
                  })
                  .catch((err) => {
                    this.$message({
                      message: `保存失败(${err[0]}):${err[1]}`,
                      type: 'error',
                    });
                  });
              },
            },
          }),
          /**
             * 设备移除按钮
             */
          h('i', {
            class: 'el-icon-delete',
            attrs: {
              type: 'checkbox',
              title: '删除',
            },
            domProps: {},
            on: {
              click: (e) => {
                e.stopPropagation();
                if (this.getCurCmpStatus) {
                  this.$message({
                    message: '当前面板正在运行，请关闭之后再进行删除',
                  });
                  return;
                }
                const projectId = this.$route.params.id;
                const deviceId = data.id;
                this.$confirm('设备删除之后，设备中的文件也将删除', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
                })
                  .then(() => {
                    this.deleteDevice({ projectId, deviceId })
                      .then(() => {
                        this.getTreeData();
                        this.getInitPanelData();
                        this.$message({
                          message: '删除成功',
                          type: 'success',
                        });
                      });
                  });
              },
            },
          }),
          /**
             * 设备取消按钮
             */
          h('i', {
            class: 'el-icon-back',
            attrs: {
              type: 'checkbox',
              title: '退出',
            },
            domProps: {},
            on: {
              click: (e) => {
                e.stopPropagation();
                const dom = e.target;
                this.deviceConfigShow[data.id] = false;
                this.doRefreshTree();
              },
            },
          }),
        ]),
        // BDC消息和A2L观测量显示的勾选框和输入框用于选择是否录制以及录制周期
        h('div', {
          style: {
            display: (() => {
              if (!(nodeType === PROJECT_NODE_TYPE.DBC_MSG || nodeType === PROJECT_NODE_TYPE.A2L_MEASURE)) {
                return 'none';
              }
              const deviceParent = this.getTreeNodeParent(node, 1);
              if (deviceParent === null) {
                console.error('没有找到当前节点的设备节点');
                console.error(node);
                return 'none';
              }
              // 当前设备id
              const deviceId = deviceParent.data.id;
              return (this.deviceConfigShow[deviceId] ? 'flex' : 'none');
            })(),
            marginLeft: '10px',
          },
        }, [
          /**
             * 消息和观测量才有的单选框
             */
          h('input', {
            attrs: {
              type: 'checkbox',
              class: 'editCheckBox',
              checked: (() => {
                if (!(nodeType === PROJECT_NODE_TYPE.DBC_MSG || nodeType === PROJECT_NODE_TYPE.A2L_MEASURE)) {
                  return false;
                }
                const deviceParent = this.getTreeNodeParent(node, 1);
                if (deviceParent === null) {
                  console.error('没有找到当前节点的设备节点');
                  console.error(node);
                  return false;
                }
                // 当前设备id
                const deviceId = deviceParent.data.id;
                // 当前设备编号
                const deviceIndex = this.treeConfigData.findIndex(item => item.deviceId === deviceId);
                const { treeConfigData } = this;
                // 当前设备数据
                const deviceData = treeConfigData[deviceIndex];
                const index = deviceData.targets.findIndex(item => item.key === data.id);
                if (index > -1) {
                  return deviceData.targets[index].enabled;
                }
                return false;
              })(),
            },
            domProps: {
              innerHTML: '',
            },
            style: {
              marginTop: 'auto',
              marginBottom: 'auto',
              marginRight: '10px',
            },
            on: {
              click: (e) => {
                e.stopPropagation();
                const dom = e.target;
                if (!(nodeType === PROJECT_NODE_TYPE.DBC_MSG || nodeType === PROJECT_NODE_TYPE.A2L_MEASURE)) {
                  return;
                }
                // if (node.level === 1) {
                //   // 已经是设备节点
                //   return '';
                // }
                const deviceParent = this.getTreeNodeParent(node, 1);
                if (deviceParent === null) {
                  console.error('没有找到当前节点的设备节点');
                  console.error(node);
                  return;
                }
                // 当前设备id
                const deviceId = deviceParent.data.id;
                const deviceIndex = this.treeConfigData.findIndex(item => item.deviceId === deviceId);
                const targetIndex = this.treeConfigData[deviceIndex].targets.findIndex(item => item.key === data.id);
                if (targetIndex > -1) {
                  this.treeConfigData[deviceIndex].targets[targetIndex].enabled = e.target.checked;
                  dom.nextSibling.disabled = !e.target.checked;
                  dom.nextSibling.nextSibling.nextSibling.disabled = !e.target.checked;
                }
              },
            },
          }),
          /**
             * 消息和观测量的interval字段的输入框
             */
          h('input', {
            domProps: {
              innerHTML: '',
              value: (() => {
                if (!(nodeType === PROJECT_NODE_TYPE.DBC_MSG || nodeType === PROJECT_NODE_TYPE.A2L_MEASURE)) {
                  return '';
                }
                const deviceParent = this.getTreeNodeParent(node, 1);
                if (deviceParent === null) {
                  console.error('没有找到当前节点的设备节点');
                  console.error(node);
                  return '';
                }
                // 当前设备id
                const deviceId = deviceParent.data.id;
                // 当前设备编号
                const deviceIndex = this.treeConfigData.findIndex(item => item.deviceId === deviceId);
                const { treeConfigData } = this;
                const deviceData = treeConfigData[deviceIndex];
                if (deviceData.targets.length > 0) {
                  const index = deviceData.targets.findIndex(item => item.key === data.id);
                  if (index === -1) {
                    console.error(`没有找到key=${data.id}节点`);
                    return '';
                  }
                  return deviceData.targets[index].interval;
                }
                return '';
              })(),
            },
            style: {
              width: '50px',
              height: '15px',
              marginTop: 'auto',
              marginBottom: 'auto',
              marginRight: '10px',
            },
            attrs: {
              disabled: (() => {
                if (!(nodeType === PROJECT_NODE_TYPE.DBC_MSG || nodeType === PROJECT_NODE_TYPE.A2L_MEASURE)) {
                  return true;
                }
                // if (node.level === 1) {
                //   // 已经是设备节点
                //   return false;
                // }
                const deviceParent = this.getTreeNodeParent(node, 1);
                if (deviceParent === null) {
                  console.error('没有找到当前节点的设备节点');
                  console.error(node);
                  return true;
                }
                // 当前设备id
                const deviceId = deviceParent.data.id;
                // 当前设备编号
                const deviceIndex = this.treeConfigData.findIndex(item => item.deviceId === deviceId);
                const { treeConfigData } = this;
                // 当前设备数据
                const deviceData = treeConfigData[deviceIndex];
                const index = deviceData.targets.findIndex(item => item.key === data.id);
                if (index > -1) {
                  return !deviceData.targets[index].enabled;
                }
                return false;
              })(),
              type: 'number',
              min: 0,
              class: 'editInput',
            },
            on: {
              click: (e) => {
                e.stopPropagation();
              },
              input: (newValue) => {
                if (!(nodeType === PROJECT_NODE_TYPE.DBC_MSG || nodeType === PROJECT_NODE_TYPE.A2L_MEASURE)) {
                  return;
                }
                const deviceParent = this.getTreeNodeParent(node, 1);
                if (deviceParent === null) {
                  console.error('没有找到当前节点的设备节点');
                  console.error(node);
                  return;
                }
                // 当前设备id
                const deviceId = deviceParent.data.id;
                // 当前设备编号
                const deviceIndex = this.treeConfigData.findIndex(item => item.deviceId === deviceId);
                const { treeConfigData } = this;
                // 当前设备数据
                const deviceData = treeConfigData[deviceIndex];
                const index = deviceData.targets.findIndex(item => item.key === data.id);
                if (index > -1) {
                  this.treeConfigData[deviceIndex].targets[index].interval = newValue.target.value !== '' ? newValue.target.value : 1;
                }
              },
            },
          }),
          /**
             * 输入框后面的单位修饰字符串
             */
          h('span', {
            attrs: {
              class: 'msg-cycle',
            },
            domProps: {
              innerHTML: (() => {
                if (!(nodeType === PROJECT_NODE_TYPE.DBC_MSG)) {
                  return;
                }
                const deviceParent = this.getTreeNodeParent(node, 1);
                if (deviceParent === null) {
                  console.error('没有找到当前节点的设备节点');
                  console.error(node);
                  return;
                }
                // 当前设备id
                const deviceId = deviceParent.data.id;
                // 当前设备编号
                const deviceIndex = this.treeConfigData.findIndex(item => item.deviceId === deviceId);
                const { treeConfigData } = this;
                // 当前设备数据
                const deviceData = treeConfigData[deviceIndex];
                const index = deviceData.targets.findIndex(item => item.key === data.id);
                if (index > -1) {
                  return (`Cycle: ${deviceData.targets[index].event}`);
                }
              })(),
            },
            style: {
              marginTop: 'auto',
              marginBottom: 'auto',
              marginRight: '10px',
            },
          }),
          /**
             * A2L观测量绑定事件列表，并默认为制定事件
             */
          h('select', {
            attrs: {
              name: 'event-select',
              disabled: (() => {
                if (!(nodeType === PROJECT_NODE_TYPE.A2L_MEASURE)) {
                  return true;
                }
                const deviceParent = this.getTreeNodeParent(node, 1);
                if (deviceParent === null) {
                  console.error('没有找到当前节点的设备节点');
                  console.error(node);
                  return true;
                }
                // 当前设备id
                const deviceId = deviceParent.data.id;
                // 当前设备编号
                const deviceIndex = this.treeConfigData.findIndex(item => item.deviceId === deviceId);
                const { treeConfigData } = this;
                // 当前设备数据
                const deviceData = treeConfigData[deviceIndex];
                const index = deviceData.targets.findIndex(item => item.key === data.id);
                if (index > -1) {
                  return !deviceData.targets[index].enabled;
                }
                return false;
              })(),
            },
            on: {
              click: (e) => {
                e.stopPropagation();
              },
              change: (newValue) => {
                if (!(nodeType === PROJECT_NODE_TYPE.A2L_MEASURE)) {
                  return;
                }
                const deviceParent = this.getTreeNodeParent(node, 1);
                if (deviceParent === null) {
                  console.error('没有找到当前节点的设备节点');
                  console.error(node);
                  return;
                }
                // 当前设备id
                const deviceId = deviceParent.data.id;
                // 当前设备编号
                const deviceIndex = this.treeConfigData.findIndex(item => item.deviceId === deviceId);
                const { treeConfigData } = this;
                // 当前设备数据
                const deviceData = treeConfigData[deviceIndex];
                const index = deviceData.targets.findIndex(item => item.key === data.id);
                if (index > -1 && newValue.target.value !== '') {
                  this.treeConfigData[deviceIndex].targets[index].event = newValue.target.value;
                }
                const checkArr = this.a2lCheckArr;
                checkArr.map((item) => {
                  if (item.measureName === node.data.text) {
                    for (const event in item) {
                      if (item[event] === true) {
                        item[event] = false;
                      }
                    }
                    if (newValue.target.value !== '暂无配置') {
                      item[newValue.target.value] = true;
                    }
                  }
                });
                const canConfigId = node.parent.parent.parent.data.id;
                this.saveA2LQuickSetting(canConfigId, checkArr);
              },
            },
            style: {
              marginTop: 'auto',
              marginBottom: 'auto',
              width: '110px',
              display: (() => {
                if (!(nodeType === PROJECT_NODE_TYPE.A2L_MEASURE)) {
                  return 'none';
                }
                return 'flex';
              })(),
            },
          }, [
            h('option', {
              domProps: {
                innerHTML: '暂无配置',
              },
            }),
            (() => {
              if (!(nodeType === PROJECT_NODE_TYPE.A2L_MEASURE)) {
                return;
              }
              const deviceParent = this.getTreeNodeParent(node, 1);
              if (deviceParent === null) {
                console.error('没有找到当前节点的设备节点');
                console.error(node);
                return;
              }
              // 当前设备id
              const deviceId = deviceParent.data.id;
              // 当前设备编号
              const deviceIndex = this.treeConfigData.findIndex(item => item.deviceId === deviceId);
              const { treeConfigData } = this;
              // 当前设备数据
              const deviceData = treeConfigData[deviceIndex];
              const index = deviceData.targets.findIndex(item => item.key === data.id);
              const eventsId = data.id.match(/(\d+)/)[0];
              if (!(nodeType === PROJECT_NODE_TYPE.A2L_MEASURE)) {
                return;
              }
              console.log('deviceData.events', deviceData.events);
              if (deviceParent === null) {
                console.error('没有找到当前节点的设备节点');
                console.error(node);
                return;
              }
              let currentEvent = '暂无配置';
              this.a2lCheckArr.map((item) => {
                if (item.measureName === node.data.text) {
                  for (const event in item) {
                    if (item[event] === true) {
                      currentEvent = event;
                    }
                  }
                }
              });
              return (
                deviceData.events[eventsId].map(value =>
                  h('option', {
                    attrs: {
                      value,
                      selected: value === currentEvent,
                    },
                    domProps: {
                      innerHTML: value,
                    },
                  }),
                ));
            })(),
          ]),
        ]),
        /**
           * A2L观测量绑定事件列表，为用户选择事件绑定带来便利
           */
        h('div', {
          style: {
            display: (() => {
              if (!(nodeType === PROJECT_NODE_TYPE.A2L_MEASURE)) {
                return 'none';
              }
              const deviceParent = this.getTreeNodeParent(node, 1);
              if (deviceParent === null) {
                console.error('没有找到当前节点的设备节点');
                console.error(node);
                return 'none';
              }
              // 当前设备id
              const deviceId = deviceParent.data.id;
              return (this.deviceConfigShow[deviceId] ? 'none' : 'flex');
            })(),
            marginLeft: '10px',
          },
        }, [
          h('select', {
            attrs: {
              name: 'event-select',
            },
            on: {
              click: (e) => {
                e.stopPropagation();
              },
              change: (newValue) => {
                const checkArr = this.a2lCheckArr;
                checkArr.map((item) => {
                  if (item.measureName === node.data.text) {
                    for (const event in item) {
                      if (item[event] === true) {
                        item[event] = false;
                      }
                    }
                    if (newValue.target.value !== '暂无配置') {
                      item[newValue.target.value] = true;
                    }
                  }
                });
                const canConfigId = node.parent.parent.parent.data.id;
                this.saveA2LQuickSetting(canConfigId, checkArr);
              },
            },
            style: {
              marginTop: 'auto',
              marginBottom: 'auto',
              width: '110px',
              display: (() => {
                if (!(nodeType === PROJECT_NODE_TYPE.A2L_MEASURE)) {
                  return 'none';
                }
                return 'flex';
              })(),
            },
          }, [
            h('option', {
              domProps: {
                innerHTML: '暂无配置',
              },
            }),
            (() => {
              if (!(nodeType === PROJECT_NODE_TYPE.A2L_MEASURE)) {
                return;
              }
              const deviceParent = this.getTreeNodeParent(node, 1);
              if (deviceParent === null) {
                console.error('没有找到当前节点的设备节点');
                console.error(node);
                return;
              }
              // 当前设备id
              const deviceId = deviceParent.data.id;
              // 当前设备编号
              const deviceIndex = this.treeConfigData.findIndex(item => item.deviceId === deviceId);
              const { treeConfigData } = this;
              // 当前设备数据
              const deviceData = treeConfigData[deviceIndex];
              const index = deviceData.targets.findIndex(item => item.key === data.id);
              const eventsId = data.id.match(/(\d+)/)[0];
              let currentEvent = '暂无配置';
              this.a2lCheckArr.map((item) => {
                if (item.measureName === node.data.text) {
                  for (const event in item) {
                    if (item[event] === true) {
                      currentEvent = event;
                    }
                  }
                }
              });
              return (
                deviceData.events[eventsId].map(value =>
                  h('option', {
                    attrs: {
                      value,
                      selected: value === currentEvent,
                    },
                    domProps: {
                      innerHTML: value,
                    },
                  }),
                ));
            })(),
          ])]),
      ]);
    },
    switchCan(event, node, data) {
      const canId = data.id;
      if (this.canBindSingleBind[canId] !== undefined) {
        this.switchPageOfCan({
          id: canId,
          targetPage: this.canSwitchValue ? 0 : 1, // 如果现在为参考页（false），就是要变成工作页（true）1
        })
          .then((res) => {
            if (res.success) {
              this.canSwitchValue = !this.canSwitchValue;
              this.$message({
                showClose: true,
                message: '设置成功！',
                type: 'success',
              });
            } else {
              this.$message({
                showClose: true,
                message: res.errorMsg,
                type: 'warning',
              });
            }
          });
      } else {
        this.$message({
          showClose: true,
          message: '请先绑定标定量组件',
          type: 'warning',
        });
      }
    },

    deviceDefaultSwitch(event, node) {
      event.stopPropagation();
    },

    // 处理tree节点拖拽
    treeDrag(event, node, data) {
      event.dataTransfer.effectAllowed = 'copyMove';
      this.setDragNodeType({ type: data.type });
      this.setDragTreeNodeKey({ key: data.id });
      event.dataTransfer.setData('dragNodeData', JSON.stringify(data));
    },

    // 增加树形结构叶子节点, 上传需要dbc、a2l或是uds父节点的canConfigid，所以传入node
    treeLeafAdd(node, data) {
      // 以下是通过mock数据来进行判断
      const type = data.text;// .slice(0, 3).toUpperCase();
      const nodeType = data.type;
      switch (nodeType) {
        case PROJECT_NODE_TYPE.DBC_ROOT:
        case PROJECT_NODE_TYPE.A2L_ROOT:
        case PROJECT_NODE_TYPE.UDS_ROOT:
        case PROJECT_NODE_TYPE.A2l_EXCEL:
          this.uploadNodeParent = node.parent.data;
          this.uploadNode = nodeType;
          this.addFileDialogVis = true;
          if (this.$refs.uploadFileCmp) {
            this.$refs.uploadFileCmp.clearFiles();
          }
          break;
        default:
          break;
      }
      const projectId = this.$route.params.id;
    },

    // 当级联发生变化
    canListChange(value) {
      this.deviceCanArr = value;
    },

    // 点击确定添加通道
    async addDeviceCanToTree() {
      this.addDevice({
        projectId: this.$route.params.id,
        deviceID: this.deviceCanArr[0],
      })
        .then((s) => {
          this.addDeviceDialogVis = false;
          this.deviceCanArr = [];
          this.addCanInput = [];
          this.$message({
            message: '添加设备成功！',
            type: 'success',
          });
          this.deviceCanArr = [];
        })
        .catch((e) => {
          this.$message({
            message: e[1],
            type: 'error',
          });
        });
    },

    addDeviceSubmit() {
      if (this.deviceCanArr.length > 0) {
        this.addDeviceCanToTree();
      } else {
        this.$message({
          message: '必须选择完整的设备和通道值',
          type: 'warning',
        });
      }
    },

    // 配置树形结构叶子节点
    treeLeafSetting(node, data) {
      // 以下是通过mock数据来进行判断
      // 阻止冒泡
      event.stopPropagation();
      const type = data.text.slice(0, 3)
        .toUpperCase();
      const nodeType = data.type;
      switch (nodeType) {
        case PROJECT_NODE_TYPE.CAN: {
          this.settingCanDialogVis = true;
          const canType = data.canType;
          projectDetailApi.getCANConfig(data.id)
            .then((res) => {
              // 传递给编辑默认参数
              this.settingCanForm = {
                canid: data.id,
                mode: res.mode ? res.mode : 0,
                baudRate: res.baudRate ? res.baudRate : '5',
                canFd: canType === CAN_TYPE.FDCan,
                dataBaudRate: res.dataBaudRate === '-1' ? '0' : res.dataBaudRate,
                canIndex: res.canIndex,
                isPlay: res.isPlay,
              };
            })
            .catch((err) => {
              this.$message({
                message: `获取通道属性失败：${err[1]}`,
                type: 'error',
              });
            });

          // const result = this.getCanConfig({ id: data.id });

          break;
        }
        case PROJECT_NODE_TYPE.DBC_ROOT:
          // this.settingDBCDialogVis = true;
          break;
        case PROJECT_NODE_TYPE.A2L_ROOT:
          this.uploadNodeParent = node.parent.data;
          this.uploadNode = nodeType;
          this.settingA2LDialogVis = true;
          this.a2lTableLoading = true;
          this.getA2LBindEventData(
            this.uploadNodeParent.id,
          )
            .then((res) => {
              this.a2lTableLoading = false;
            });
          break;
        default:
          break;
      }
    },


    // 通道配置
    async settingCANSubmit() {
      const { canid, mode, baudRate, canIndex, dataBaudRate, isPlay } = this.settingCanForm;
      this.settingCan({
        id: canid,
        mode,
        baudRate,
        dataBaudRate,
        canIndex,
        isPlay,
      })
        .then(() => {
          this.settingCanDialogVis = false;
          if (this.getCurCmpStatus) {
            this.$message({
              message: '配置成功，将在重启面板后生效',
              type: 'info',
            });
          } else {
            this.$message({
              message: '配置成功',
              type: 'success',
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: '配置失败，请重新尝试',
            type: 'error',
          });
        });
    },

    // 上传文件，根据uploadNode来判断
    async uploadNodeFile(uploadComponet) {
      // 检查是否允许上传
      const formData = new FormData();
      formData.append('file', uploadComponet.file);
      formData.append('projectId', this.$route.params.id);
      if (this.uploadNode === PROJECT_NODE_TYPE.DBC_ROOT) {
        formData.append('type', '1');
      } else if (this.uploadNode === PROJECT_NODE_TYPE.A2L_ROOT) {
        formData.append('type', '2');
      } else if (this.uploadNode === PROJECT_NODE_TYPE.A2l_EXCEL) {
        formData.append('type', '4');
      } else {
        formData.append('type', '3');
      }
      this.updateLoading = this.$loading({
        lock: true,
        text: '正在校验文件，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      this.canUpload = true;
      request.postForm('project/uploadFile', formData)
        .then((res) => {
          this.updateLoading.close();
          this.uploadPath = res;
        })
        .catch((err) => {
          this.updateLoading.close();
          if (this.$refs.uploadFileCmp) {
            this.$refs.uploadFileCmp.clearFiles();
          }
          this.$message({
            message: `文件上传失败，请检查后尝试 ${err[1]}(${err[0]})`,
            type: 'error',
          });
        });
    },

    handleExceed() {
      this.$message.warning('最多支持同时上传1个文件');
    },

    // 在uploadNodeFile方法返回path之后调用
    async uploadFile() {
      // 避免不必要的解析等待，提升用户体验
      this.$message({
        message: '文件解析中，请稍候',
        type: 'info',
      });
      this.addFileDialogVis = false;
      let result;
      try {
        result = await
        this.projectAddNodeFile({
          path: this.uploadPath,
          projectId: this.$route.params.id,
          canConfigId: this.uploadNodeParent.id,
          nodeType: this.uploadNode,
        });
      } catch (e) {
        console.error(e);
        result = undefined;
      }
      if (result === undefined) {
        this.$message({
          message: '文件解析出错，请检查后尝试',
          type: 'error',
        });
      }
      if (result) {
        this.$message({
          message: '文件已上传并成功解析',
          type: 'success',
        });
        // 刷新左边的树结构
        this.getTreeData();
        // this.dialogTableVisible = true;
        this.addDBCOrA2LDialogVis = false;
        if (this.$refs.uploadDBCOrA2LCmp) {
          this.$refs.uploadDBCOrA2LCmp.clearFiles();
          this.addFileDialogVis = false;
          if (this.$refs.uploadFileCmp) {
            this.$refs.uploadFileCmp.clearFiles();
          }
        }
      }
    },

    cancelUpload() {
      this.addFileDialogVis = false;
      this.uploadPath = '';
      this.canUpload = false;
      if (this.$refs.uploadFileCmp) {
        this.$refs.uploadFileCmp.clearFiles();
      }
    },

    cancelA2LSetting() {
      this.settingA2LDialogVis = false;
    },

    // 由于一个观测name只能有一个eventname，一个eventname可以对应多个观测name
    checkEventName(newValue, ...args) {
      const expectArr = ['measureName'];
      const [rowData, eventName] = args;
      // 清除其他的checkbox
      Object.entries(rowData)
        .forEach((item) => {
          if (!expectArr.includes(item[0])) {
            rowData[item[0]] = false;
          }
        });
      rowData[eventName] = newValue;
    },

    async saveA2LSetting() {
      const result = await
      this.a2lBindEvent({
        checkArr: this.a2lCheckArr,
        canConfigId: this.uploadNodeParent.id,
      });
      if (result) {
        if (this.getCurCmpStatus) {
          this.$message({
            message: '配置成功，将在重启面板后生效',
            type: 'success',
          });
        } else {
          this.$message({
            message: '配置成功',
            type: 'success',
          });
        }
        this.a2lCheckArr = JSON.parse(JSON.stringify(this.a2lBindEventData.data));
      } else {
        this.$message({
          message: '配置失败',
          type: 'error',
        });
      }
    },
    async saveA2LQuickSetting(canConfigId, checkArr) {
      console.log('checkarr', checkArr);
      const result = await
      this.a2lBindEvent({
        checkArr,
        canConfigId,
      });
      if (result) {
        if (this.getCurCmpStatus) {
          this.$message({
            message: '配置成功，将在重启面板后生效',
            type: 'success',
          });
        } else {
          this.$message({
            message: '配置成功',
            type: 'success',
          });
        }
        this.a2lCheckArr = JSON.parse(JSON.stringify(this.a2lBindEventData.data));
      } else {
        this.$message({
          message: '配置失败',
          type: 'error',
        });
      }
    },
  },
};
</script>


<style lang="scss">
  .dom_flex {
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    align-items: center;
  }

  .el-dialog__body {
    padding-top: 20px;
  }

  .transfer {
    .el-transfer-panel {
      width: 380px;
    }
  }

  .el-tree-node__content {
    height: auto;
  }

  .el-tree-node__content {
    height: auto !important;
  }

  .left-aside {
    .search-add {
      background: #fff;
      height: 52px;
    }

    .add-can-btn {
      float: right;
      margin-top: 10px;
      margin-right: 20px;
    }
  }

  .a2l-setting {
    .el-dialog__body {
      height: 400px;
      overflow: auto;
    }
  }

  .a2l-list {
    .transfer-footer {
      display: flex;
      margin-left: 45%;
      margin-top: 3px;
    }

    .box-card {
      margin: 20px 20px;

      .el-card__header {
        background: #F5F7FA;
        height: 60px;
        padding: 15px 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/engineering/LeftAside.vue